import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { jsxJoin } from "@devowl-wp/react-utils";
import { CookieProperty } from "./cookieProperty.js";
import { useStylesheet } from "../../../contexts/stylesheet.js";
import { createSuperScriptTagFactory } from "../../../hooks/common/useTeachings.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
import { calculateSafetyMechanismsFromSpecialTreatments } from "../../../others/calculateSafetyMechanismsFromSpecialTreatments.js";
const CookiePropertyDataTransmission = (param)=>{
    let { mechanisms, ...service } = param;
    const { screenReaderOnlyClass } = useStylesheet();
    const createSuperScriptTag = createSuperScriptTagFactory(screenReaderOnlyClass);
    const { iso3166OneAlpha2, predefinedDataProcessingInSafeCountriesLists, territorialLegalBasis, isDataProcessingInUnsafeCountries, i18n: { dataProcessingInThirdCountries, territorialLegalBasisArticles: { "dsg-switzerland": { dataProcessingInUnsafeCountries: territorialLegalBasisArticleDataProcessingInUnsafeCountriesDsg }, "gdpr-eprivacy": { dataProcessingInUnsafeCountries: territorialLegalBasisArticleDataProcessingInUnsafeCountriesGdpr } }, safetyMechanisms: { label, eu, switzerland, adequacyDecision, contractualGuaranteeSccSubprocessors, standardContractualClauses, bindingCorporateRules } } } = useBannerOrBlocker();
    const { result, filter, isGdpr } = calculateSafetyMechanismsFromSpecialTreatments({
        predefinedDataProcessingInSafeCountriesLists,
        territorialLegalBasis,
        isDataProcessingInUnsafeCountries,
        service
    });
    const entries = Object.entries(result);
    const mechanismToText = {
        A: adequacyDecision,
        "A-EU": `${adequacyDecision} (${eu})`,
        "A-CH": `${adequacyDecision} (${switzerland})`,
        B: standardContractualClauses,
        C: contractualGuaranteeSccSubprocessors,
        D: territorialLegalBasis.length > 1 ? "" : isGdpr ? territorialLegalBasisArticleDataProcessingInUnsafeCountriesGdpr : territorialLegalBasisArticleDataProcessingInUnsafeCountriesDsg,
        "D-EU": territorialLegalBasisArticleDataProcessingInUnsafeCountriesGdpr,
        "D-CH": territorialLegalBasisArticleDataProcessingInUnsafeCountriesDsg,
        E: bindingCorporateRules
    };
    const usedMechanisms = Object.keys(mechanismToText).filter((mechanism)=>filter((b)=>b === mechanism).length > 0);
    const allMechanisms = mechanisms ? mechanisms(usedMechanisms) : usedMechanisms;
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            entries.length > 0 && /*#__PURE__*/ _jsx(CookieProperty, {
                label: dataProcessingInThirdCountries,
                value: jsxJoin(entries.map((param)=>{
                    let [country, mechanism] = param;
                    return /*#__PURE__*/ _jsx("span", {
                        dangerouslySetInnerHTML: {
                            __html: createSuperScriptTag(mechanism.map((m)=>[
                                    m,
                                    mechanismToText[m]
                                ]), iso3166OneAlpha2[country] ?? country)
                        }
                    }, country);
                }), ", ")
            }),
            allMechanisms.length > 0 && /*#__PURE__*/ _jsx(CookieProperty, {
                label: label,
                value: jsxJoin(allMechanisms.map((mechanism)=>/*#__PURE__*/ _jsx("span", {
                        dangerouslySetInnerHTML: {
                            __html: mechanismToText[mechanism] ? createSuperScriptTag([
                                [
                                    mechanism
                                ]
                            ], mechanismToText[mechanism]) : mechanism
                        }
                    }, mechanism)), ", ")
            })
        ]
    });
};
export { CookiePropertyDataTransmission };
